/**
 * Proposal-specific design tokens
 * These tokens are used exclusively for the proposal template
 * and are separate from the main application design system
 */

export const proposalTokens = {
  colors: {
    // Template 4 color palette
    teal: '#1a4d54',      // Deep green/teal
    gold: '#f3ad0f',      // Yellow/orange/gold (primary accent)
    cream: '#efede7',     // Beige/cream background
    
    // Gold variations
    goldDark: '#d97706',  // Darker gold for hover states
    goldLight: '#fbbf24', // Lighter gold
    
    // Teal variations
    tealLight: '#2d6b75', // Lighter teal
    tealDark: '#0f3a3f',  // Darker teal
    
    // Neutral colors for proposal
    white: '#ffffff',
    black: '#000000',
  },
  
  typography: {
    // Font families - loaded via Google Fonts
    fontFamily: {
      sans: ['Lato', 'Arial', 'sans-serif'],
      serif: ['EB Garamond', 'Georgia', 'serif'],
    },
    
    // Font weights
    fontWeight: {
      light: '300',
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      black: '900',
    },
  },
  
  spacing: {
    // Standard spacing scale
    xs: '0.5rem',   // 8px
    sm: '1rem',     // 16px
    md: '1.5rem',   // 24px
    lg: '2rem',     // 32px
    xl: '3rem',     // 48px
    '2xl': '4rem',  // 64px
  },
  
  borderRadius: {
    sm: '0.5rem',   // 8px
    md: '1rem',     // 16px
    lg: '1.5rem',   // 24px
    full: '9999px', // Full rounded
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    gold: '0 10px 15px -3px rgba(243, 173, 15, 0.2)', // Gold shadow
  },
} as const;

// Export individual token groups for easier imports
export const { colors, typography, spacing, borderRadius, shadows } = proposalTokens;

